<template>
  <v-card elevation="1" class="styleCard">
    <date-range-picker
      class="pa-1"
      ref="picker"
      opens="right"
      :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }"
      :singleDatePicker="false"
      :timePicker="true"
      :timePicker24Hour="true"
      :autoApply="true"
      v-model="dateRange"
      @update="changeDate"
    >
      <div slot="header" class="slot">
        <h3 class="text-primary-color">Calendario</h3>
      </div>
      <template v-slot:input="picker">
        <span
          style="color: rgb(146, 102, 102); text-align: center;"
          v-if="picker.startDate === null"
          >Rango de Fecha</span
        >
        <span
          style="color: black; text-align: left;"
          v-if="picker.startDate != null"
        >
          {{ picker.startDate | date }} - {{ picker.endDate | date }}
        </span>
      </template>
    </date-range-picker>
  </v-card>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  props: {},
  components: {
    DateRangePicker,
  },
  data() {
    const startDate = new Date();
    const endDate = new Date();
    startDate.setDate(startDate.getDate() - 5);
    startDate.setHours(0, 0);
    endDate.setHours(23, 59);
    return {
      menu: false,
      dateRange: { startDate, endDate },
    };
  },
  filters: {
    date(val) {
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false,
      };
      return val ? val.toLocaleDateString("es", options) : "";
    },
  },
  computed: {},
  methods: {
    changeDate(value) {
      this.$emit("change", value);
    },
  },
  mounted() {
    this.$emit("change", this.dateRange);
  },
};
</script>
<style lang="scss">
@import "../styles/global.scss";
.slot {
  background-color: $background-secondary;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
}
.styleCard {
  cursor: pointer;
  padding: 5px 10px;
  border: 1px;
  width: 100%;
  border-radius: 10px;
}
.reportrange-text[data-v-00277188] {
  /* background: #fff; */
  cursor: pointer;
  padding: 3px 1px;
  border: 1px;
  width: 100%;
}
.daterangepicker .ranges li.active {
  background-color: dodgerblue;
  color: #fff;
}
.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: $background-tertiary;
  border-color: transparent;
  color: #fff;
}
.daterangepicker td.in-range {
  background-color: $background-tertiary;
  border-color: transparent;
  color: #fff;
  border-radius: 0;
}
</style>
